import React from 'react'
import { Link } from 'react-router-dom'
import Header from './component/IndexPageFA/Header'
import ProductCstegoryAhan from './component/IndexPageFA/ProductCstegoryAhan'
import AboutCompony from './component/IndexPageFA/AboutCompony'
import ProductCstegorySang from './component/IndexPageFA/ProductCstegorySang'
import SliderImageCompony from './component/IndexPageFA/SliderImageCompony'
import NewsCompony from './component/IndexPageFA/NewsCompony'
import AddressAndCommunication from './component/IndexPageFA/AddressAndCommunication'
import Footer from './component/IndexPageFA/Footer'

function Indexfa() {
  return (
    <div>
      <Header>
        <div className="logo-container">
          <img src="image/logo-banner-slider.png" alt="logo" className="logo" />
        </div>
        
        <div className="titleFA">
        گروه تجارت پهلوان مقدم
        </div>
        <div className="items">
          <Link className="item sang" to={"product?name=stone"} >
            <div className="item sang">
              <div className='shadoText-Sang'></div>
                {/* <img src="image/cat-1.jpg" alt="item1" className="item-image" /> */}
                <img src="image/Sang.jpg" alt="item1" className="item-image" />
              <div>
                <h3 className='titleMiddle-sang'>  سنگ </h3>
                <div className='discription item-text-sang' style={{textAlign: "start" , left: "20px"}}>
                  <h3>  سنگ  </h3>
                  <p > گروه سنگ شامل انواع سنگ‌های طبیعی برای ساخت‌وساز و دکوراسیون است </p>
                </div>
              </div>
            </div>
          </Link>
          <Link  className="item ahan" to={"product?name=iron"}>
          <div className="item ahan">
            <div className="shadoText-Ahan"></div>
            {/* <img src="image/cat-2.jpg" alt="item2" className="item-image" /> */}
            <img src="image/Ahan.jpg" alt="item2" className="item-image" />
              <div>
                <h3 className='titleMiddle-ahan'>  آهن </h3>
                <div className='discription item-text-ahan' style={{textAlign: "end" , right: "20px"}}>
                  <h3>  آهن </h3>
                  <p>   گروه آهن شامل محصولات فلزی مانند تیرآهن، میلگرد و نبشی برای ساخت‌وساز است </p>
                </div>
              </div>
          </div>
          </Link>
        </div>
      </Header>
      <ProductCstegoryAhan />
      <AboutCompony />
      <ProductCstegorySang />
      <SliderImageCompony />
      <NewsCompony />
      <AddressAndCommunication />
      <Footer />
    </div>
  )
}

export default Indexfa

